import styled from 'styled-components';
import { theme } from '@ovotech/element-v5';

export const Box = styled.div`
  display: inline-flex;
  align-items: center;
  gap: ${theme.space[300]};
  padding: ${theme.space[400]};
  border-radius: ${theme.border.radius.lg};
  border: 1px solid ${theme.color.surface.borderDim};
  background-color: ${theme.color.surface.surface};
`;

export const Code = styled.span`
  font-size: ${theme.font.size.lg.mediaQuery.lg};
  letter-spacing: 1.5px;
`;

export const CopyButton = styled.button`
  padding: 0;
  border: none;
  background: none;
  cursor: pointer;
`;
